<template>
  <div class="HomeFooter">
    <div class="banner" v-if="route.meta.bannerShow">
      <div class='banner_text'>
          <div>扫描二维码</div>
          <div>随时下单更方便、快捷</div>
          <div>商务专享 极致体验 !!!</div>
      </div>  
      <div class='img_content'>
        <img src="@assets/img/phone.png" class='phone'/>
        <img src="@assets/img/code.png" class='code'/>
      </div>
    </div>
    <a-row class="main">
      <a-col :span="6">
        <img src="@assets/img/btm1.png" />
        <div>
          <span>服务热线</span>
          <br />
          <span>010-88888888</span>
        </div>
      </a-col>
      <a-col :span="6">
        <img src="@assets/img/btm2.png" />
        <div>
          <span>商服邮箱</span>
          <br />
          <span> business@tianxiapiao.cn</span>
        </div>
      </a-col>
      <a-col :span="6">
        <img src="@assets/img/btm3.png" />
        <div>
          <span>机票业务</span>
          <br />
          <span> plane@tianxiapiao.cn</span>
        </div>
      </a-col>
      <a-col :span="6">
        <img src="@assets/img/btm4.png" />
        <div>
          <span>技术问题</span>
          <br />
          <span> technology@tianxiapiao.cn</span>
        </div>
      </a-col>
    </a-row>
    <div class="bottom">
      Copyright©2016-2023, tianxiapiao.cn. All rights reserved. |
      ICP证：京ICP备16041718号-2
    </div>
  </div>
</template>
<script>
import { useRouter, useRoute } from 'vue-router'
export default {
  componentname: "HomeFooter",
  props: {

  },
  setup () {
    const router = useRouter()
    const route = useRoute()


    return {
      route,
      router,

    }
  }
}
</script>
<style  rel="stylesheet/scss" lang="scss" scoped>
.banner_text{
  font-size: 22px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #0D6DBF;
  line-height: 30px;
  letter-spacing: 1px;
}
.banner {
  width: 1200px;
  height: 226px;
  margin: 0 auto;
  background: linear-gradient(169deg, #F6FBFF 0%, #E5F5FF 100%);
  border-radius: 5px;
  position: relative;
  padding:30px 34px;
  .img_content{
    position: absolute;
    right: 50px;
    bottom:0px;
    .phone{
      width: 170px;
    }
    .code{
      width: 140px;
      position: absolute;
      right: 17px;
      bottom: 45px;
    }
  }
}
.main {
  width: 1200px;
  height: 44px;
  margin: 72px auto 53px;
  background: #ffffff;
  .ant-col {
    text-align: left;
    img {
      width: 45px;
      margin-right: 12px;
      vertical-align: bottom;
    }
    div {
      display: inline-block;
      margin-left: 15px;
    }
  }
}
.bottom {
  width: 100%;
  height: 200px;
  line-height: 200px;
  text-align: center;
  background: #f8f8f8;
  font-size: 14px;
  color: #979797;
}
</style>
